import ChatDetailRate from './ChatDetailRate';

export default ChatDetailRate;
